export default __webpack_public_path__ + "static/Sailec-Bold-64ce832f00efec585399963406cd3cba.woff2";